import { call, put, takeEvery } from 'redux-saga/effects';
import { dpNewsFeedActionCreators, DpNewsFeedActionKeys, IDpNewsFeedPost, UpdateDpNewsFeedPost } from '..';
import { getUrl } from '../../../layout/layoutConstants';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateDpNewsFeedPost } from '../dpNewsFeedApi';

function* updateDpNewsFeedPostSaga(action: UpdateDpNewsFeedPost) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IEntityWithMessages<IDpNewsFeedPost>> = yield call(
    updateDpNewsFeedPost,
    action.payload.post
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(dpNewsFeedActionCreators.setPosts([response.value.value]));

      if (action.payload.post.dpNewsFeedPostId !== response.value.value.dpNewsFeedPostId) {
        action.payload.pushFunc(getUrl.newsFeedPost(response.value.value.dpNewsFeedPostId));
      }
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateDpNewsFeedPost() {
  yield takeEvery(DpNewsFeedActionKeys.UPDATE_DP_NEWS_FEED_POST, updateDpNewsFeedPostSaga);
}
